import { AxiosError, AxiosResponse } from 'axios';
import { settings } from '../settings';
import { v4 as uuidv4 } from 'uuid';
import { setBusy, resetBusy } from '../store/slice/BusySlice';
import { AppStore } from '../store/AppStore';
import AxiosClient from './AxiosClient';
import { SessionStore } from '../services/SessionStore';
import { oidcSettings } from './OidcSettings';

export const getAuthToken = () => {
  const sessionKey = `oidc.user:${oidcSettings.AuthorityUrl}:${oidcSettings.ClientId}`;
  return SessionStore.get(sessionKey)?.access_token;
};

AxiosClient.interceptors.request.use((config) => {
  if (!config.headers.skipLoader) {
    AppStore.dispatch(setBusy());
  }
  const token = getAuthToken();
  config.headers['X-CORRELATION-ID'] = uuidv4();
  config.headers['Context'] = settings.Context;
  config.headers['Content-Type'] = 'application/json; charset=utf-8';
  config.headers['Accept'] = 'application/json';
  config.headers['X-Requested-With'] = 'CfLM-PHC-Admin';
  config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

AxiosClient.interceptors.response.use(
  (response: AxiosResponse) => {
    AppStore.dispatch(resetBusy());
    return response;
  },
  (error: AxiosError) => {
    AppStore.dispatch(resetBusy());
    return Promise.reject(error);
  }
);
